import styled, { css } from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

interface ItemGroupProps {
  align?: 'left' | 'right';
}

export const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const Anchor = styled.a`
  display: block;
  padding: 20px 0;
`;

export const Content = styled.div`
  ${getFontStyle('midium150_B3')};
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.gray900};
  text-align: left;
`;

export const InfoWrapper = styled.div`
  display: flex;
`;

export const ThumbsUpWrapper = styled.div`
  position: relative;
  top: -1px;
`;
export const ThumbsDownWrapper = styled.div`
  position: relative;
  top: 1px;
`;

export const ItemGroup = styled.div<ItemGroupProps>`
  display: flex;
  gap: 0 20px;

  ${({ align }) =>
    align === 'right' &&
    css`
      margin-left: auto;
    `}
`;

export const InfoItem = styled.div`
  ${getFontStyle('midium150_C1')};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray700};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 6px;
  background: none;
  border-width: 0;
`;

export const Comment = styled(Text)`
  position: relative;
  margin-left: 10px;
  background-color: ${({ theme }) => theme.colors.gray300};
  color: ${({ theme }) => theme.colors.gray800};
  font-size: 8px;
  padding: 2px 3px;
  border-radius: 2px;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: 1px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #e6e6e6;
    position: absolute;
    bottom: -5px;
    left: 4px;
  }
`;
